export const environment = {
    smartPortalApiUrl: 'https://app-seh-uat-uks-001.azurewebsites.net/api/',
    seedFunctionApiUrl: '',
    msalConfig: {
        auth: {
            clientId: '24568683-819e-401a-862b-3fe492cd0272',
            authority: 'https://login.microsoftonline.com/organizations',
            redirectUri: 'https://uat.seh.icshosting.net/auth',
        },
    },
    apiConfig: {
        scopes: ['api://7171a077-6907-4a14-bf33-2469a0dd218f/access_as_user'],
        uri: 'https://app-seh-uat-uks-001.azurewebsites.net/',
    }
};
